/**
 * Build a querystring from a params object, skipping null/undefined values.
 *
 * Array values are appended once per item under the same key (e.g.
 * `{ coach_id: ["a", "b"] }` → `?coach_id=a&coach_id=b`), which matches how
 * the ms-agents oversight API accepts repeatable params. An empty array
 * contributes no params for that key. Scalar values behave as before.
 *
 * @param {Object} [params] - Key/value pairs to serialize. Values may be a
 *   scalar (string/number/boolean), `null`/`undefined` (skipped), or an
 *   array of scalars (appended repeatedly, skipping any `null`/`undefined`
 *   items).
 * @returns {string} A querystring beginning with `?` (e.g. `?a=1&b=2`), or an
 *   empty string when there are no usable params.
 */
export const buildQuery = (params) => {
  if (!params) return "";
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === null || item === undefined) return;
        search.append(key, item);
      });
      return;
    }
    search.append(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};
